import type { ScreenModule } from "../../../app/screen-module";
import { ProductDashboardPage } from "../pages";

export default {
	id: "system-admin.dashboard",
	path: "/system",
	area: "system-admin",
	navGroup: "製品",
	label: "ダッシュボード",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ProductDashboardPage,
} satisfies ScreenModule;
